module.exports = __webpack_public_path__ + "static/logo-light-004b227271a4a83806c12439bbbc5d36.svg";